import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ASK_ERROR_VIEWS, AskErrorKind, AskErrorView } from 'src/app/enums/askErrorKind.enum';

@Component({
  standalone: false,
  selector: 'app-chat-turn-error',
  templateUrl: './chat-turn-error.component.html',
  styleUrls: ['./chat-turn-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatTurnErrorComponent implements OnChanges {
  @Input() kind: AskErrorKind = AskErrorKind.Generic;
  @Input() message: string | null = null;
  @Input() retryAfterSeconds: number | null = null;
  @Output() retry = new EventEmitter<void>();

  view: AskErrorView = ASK_ERROR_VIEWS[AskErrorKind.Generic];
  retryHintSeconds: number | null = null;

  ngOnChanges(): void {
    const base = ASK_ERROR_VIEWS[this.kind];
    this.view = this.message ? { ...base, message: this.message } : base;
    this.retryHintSeconds =
      this.kind === AskErrorKind.RateLimited && this.retryAfterSeconds && this.retryAfterSeconds > 0
        ? this.retryAfterSeconds
        : null;
  }

  onRetryClick(): void {
    this.retry.emit();
  }
}
